<i18n>
[
    "product__colorInfo--label",
]
</i18n>

<template>
    <div>
        <div class="o-text--caption u-spacer--1">
            {{ $t('product__colorInfo--label') }}:
            <span class="u-text--gray">
                {{ displayName }}
            </span>
        </div>
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'ProductColorSelectorPanel',
    props: {
        displayName: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
</style>
